// api/PayablePdf.api.ts

import apiHandler from "../core/apiHandler";


/**
 * 📄 API base para exportación PDF
 * de cuentas por pagar
 *
 * Endpoint:
 * /api/pdf/Payables
 */
const PayablePdfApi = apiHandler("pdf/payables");

export default PayablePdfApi;